/**
 * The console's own antd tokens (text, font, radius, menu tints). The brand
 * colour and the button look come from the app theme (theme/dataqTheme.ts),
 * which this nests inside and inherits.
 */
export const QC_THEME = {
  token: {
    colorText: "#1A1817",
    colorTextSecondary: "#5C544B",
    colorBgContainer: "#FFFFFF",
    borderRadius: 4,
    fontFamily: '"General Sans", system-ui, sans-serif',
    // Tinted accent for menu/dropdown hover and selected states. Default
    // tokens give a flat grey/black hover that fights the warm-paper theme;
    // these tints keep hover legible and on-brand.
    controlItemBgHover: "rgba(54, 195, 237, 0.10)",
    controlItemBgActive: "rgba(54, 195, 237, 0.18)",
    controlItemBgActiveHover: "rgba(54, 195, 237, 0.22)",
  },
}
